import UploadsManager from '../../layout/admin/UploadManager';

export default function Dashboard() {
  return (
    <>
      <div className="flex-colomn gap-2">
        <UploadsManager />
      </div>
    </>
  );
}
